import { Typography } from "@mui/material"
import { Box } from "@mui/system"

const ReadMessageBox = ({ message, title, bgColor }) => {
  return (
    <Box>
      <Typography mb={1} fontWeight={500} variant="h5">
        {title}
      </Typography>
      <Box p={3} borderRadius="2px" backgroundColor={bgColor}>
        <Typography variant="h6">{message}</Typography>
      </Box>
    </Box>
  )
}

export default ReadMessageBox
